module.exports = __webpack_public_path__ + "static/media/ic_verify_otp_finity.8f74591d.svg";